import Head from 'next/head'

import { useCompany } from '@/hooks/useCompany'

type THeader = {
  title: string
}

export const Header = ({ title }: THeader) => {
  const company = useCompany()
  return (
    <Head>
      <title>{`${title} | ${company?.name} | Barchart Marketplace`}</title>
      <meta
        name="description"
        content={`${title} | ${company?.name} | Barchart Marketplace`}
        key="desc"
      />
    </Head>
  )
}
